exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".valueContent {\n  word-wrap: break-word !important; }\n\nbutton {\n  color: #ffffff; }\n\n.report-generate-button {\n  padding: 0 25px !important; }\n\n.loading-circle {\n  position: absolute !important;\n  top: 5px !important;\n  right: 3px !important; }\n\n::ng-deep .loading-circle circle {\n  stroke: #fff !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/user-logs/user-logs.component.scss
// module id = ../../../../../src/app/shared/components/user-logs/user-logs.component.scss
// module chunks = main